import { render, staticRenderFns } from "./ProductHistoryModal.vue?vue&type=template&id=366e697b&scoped=true"
import script from "./ProductHistoryModal.vue?vue&type=script&lang=js"
export * from "./ProductHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./ProductHistoryModal.vue?vue&type=style&index=0&id=366e697b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e697b",
  null
  
)

export default component.exports